import React, { memo, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { useConfig } from '@browsing/config';
import { scrollToTop } from '@browsing/utils';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Translate } from '@pegasus/translation';
import { trackSelectContent, trackViewContent } from '@browsing/tracking';
import { InView } from 'react-intersection-observer';
import { RoundButton } from '../round-button';
import { ChatBox } from './chat-box';
import { BottomBubbleContext } from './context';
import * as S from './styles';
var DEBOUNCE_TIME = 100;
var SHOW_BACK_TO_TOP_THRESHOLD = 500;
var PLUS_CTA_THRESHOLD = 315;
var PLUS_DEBOUNCE_TIME = 10;
var onScrollClick = function () { return scrollToTop(); };
export var BottomBubble = function (_a) {
    var children = _a.children, customer = _a.customer, loyaltyEAVariant = _a.loyaltyEAVariant, onPlusCtaClick = _a.onPlusCtaClick;
    var config = useConfig();
    // Initialize to false - this is important for ensuring it's hidden by default
    var _b = useState(false), isPlusCTAOpen = _b[0], setIsPlusCTAOpen = _b[1];
    var _c = useState(false), isBackToTopButtonShown = _c[0], setBackToTopButtonShown = _c[1];
    var _d = useState(0), marginBottom = _d[0], setMarginBottom = _d[1];
    useEffect(function () {
        if (!loyaltyEAVariant) {
            return;
        }
        var onScroll = debounce(function () {
            if (window.scrollY > PLUS_CTA_THRESHOLD) {
                setIsPlusCTAOpen(true);
            }
            else {
                setIsPlusCTAOpen(false);
            }
        }, PLUS_DEBOUNCE_TIME);
        window.addEventListener('scroll', onScroll);
        // We don't trigger the check on initial mount to ensure it starts hidden
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    useEffect(function () {
        var onScroll = debounce(function () {
            if (window.scrollY > SHOW_BACK_TO_TOP_THRESHOLD) {
                if (!isBackToTopButtonShown) {
                    setBackToTopButtonShown(true);
                }
            }
            else {
                setBackToTopButtonShown(false);
            }
        }, DEBOUNCE_TIME);
        window.addEventListener('scroll', onScroll);
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, [isBackToTopButtonShown]);
    var handleTurnOnPlusCtaClick = function () {
        if (!onPlusCtaClick) {
            return;
        }
        trackSelectContent('loyalty_opt_in_footer', 'click', {
            contentId: 'turn_on_plus',
        });
        onPlusCtaClick();
    };
    var trackImpression = function (inView, loyaltyEAVariant) {
        if (!loyaltyEAVariant || !inView) {
            return;
        }
        trackViewContent('loyalty_opt_in_footer', 'view');
    };
    return (React.createElement(BottomBubbleContext.Provider, { value: setMarginBottom },
        children,
        React.createElement(S.Container, { "$bottom": marginBottom || 0, "$isCTAOpen": isPlusCTAOpen },
            config.isEnabled('livechat') && React.createElement(ChatBox, { customer: customer }),
            React.createElement(S.ArrowContainer, { "$visible": isBackToTopButtonShown },
                React.createElement(RoundButton, { onClick: onScrollClick },
                    React.createElement(S.ArrowUpIcon, null)))),
        loyaltyEAVariant && (React.createElement(S.PlusCTAContainer, { key: "plus-cta", "$isOpen": isPlusCTAOpen },
            React.createElement(InView, { as: "div", onChange: function (inView) { return trackImpression(inView, loyaltyEAVariant); }, triggerOnce: true, threshold: 0.9 },
                React.createElement(Button, { buttonType: ButtonType.primary, style: { width: '100%' }, color: ButtonColor.dark, onClick: handleTurnOnPlusCtaClick },
                    React.createElement(Translate, { message: "plus.cta" })))))));
};
export default memo(BottomBubble);
